var _defs, _path, _g, _g2, _g3, _g4, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNz = function SvgNz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 -.325)",
    d: "M0 0v.5L1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-36 .5 -.162)",
    d: "M0 0v-.5L1 0z"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72 0 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-72 0 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1) rotate(72)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v300H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.004 0h640v480h-640z",
    fill: "#00247d",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92.947 36.115) scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(45.4 0 0 45.4 900 120)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#cc142b",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(30 0 0 30 900 120)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 534.179 124.977) scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-82 519.022 -457.666) scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#cc142b",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-82 519.022 -457.666) scale(25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 534.179 124.977) scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-82 668.57 -327.666) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#cc142b",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-82 668.57 -327.666) scale(30)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92.947 36.115) scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(50.4 0 0 50.4 900 480)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#cc142b",
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "matrix(35 0 0 35 900 480)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#c)",
    d: "M0 0l600 300M0 300L600 0",
    transform: "matrix(.60681 0 0 .73139 .004 0)",
    stroke: "#fff",
    strokeWidth: 60
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    d: "M0 0l600 300M0 300L600 0",
    transform: "matrix(.60681 0 0 .73139 .004 0)",
    stroke: "#cc142b",
    strokeWidth: 40
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    clipPath: "url(#c)",
    d: "M151.707-.002v79.37H.004v60.68h151.703v79.37h60.682v-79.37h151.703v-60.68H212.389V-.003z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M163.844.002v91.502H.004v36.408h163.84v91.502h36.408v-91.502h163.84V91.504h-163.84V.002z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible",
    fill: "#cc142b"
  }));
};
export default __webpack_public_path__ + "assets/ebccddfef9838f97fe368551763640dd.svg";
export { SvgNz as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/nz.svg